var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknowError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 72,
    viewBox: "0 0 87 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.5574,
    cy: 35.7554,
    rx: 43.1585,
    ry: 35.2639,
    fill: "#FEECEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4999 51.7368C33.7183 51.7368 25.6447 44.6211 25.6447 36C25.6447 27.3789 33.7183 20.2632 43.4999 20.2632C53.2815 20.2632 61.3552 27.3789 61.3552 36C61.3552 44.6211 53.2815 51.7368 43.4999 51.7368ZM43.4999 21.7684C34.6499 21.7684 27.3525 28.2 27.3525 36C27.3525 43.8 34.6499 50.2316 43.4999 50.2316C52.3499 50.2316 59.6473 43.8 59.6473 36C59.6473 28.2 52.3499 21.7684 43.4999 21.7684Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.892 31.7579L40.7051 36L35.892 40.2421L38.6867 42.7053L43.4999 38.4632L48.313 42.7053L51.1078 40.2421L46.2946 36L51.1078 31.7579L48.313 29.2947L43.4999 33.5368L38.6867 29.2947L35.892 31.7579Z",
    fill: "#EF3829"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3131 43.8L43.4999 39.5579L38.6867 43.8L34.6499 40.2421L39.4631 36L34.6499 31.7579L38.6867 28.2L43.4999 32.4421L48.3131 28.2L52.3499 31.7579L47.5367 36L52.3499 40.2421L48.3131 43.8ZM37.1341 40.2421L38.6867 41.6105L43.4999 37.3684L48.3131 41.6105L49.8657 40.2421L45.0525 36L49.8657 31.7579L48.3131 30.3895L43.4999 34.6316L38.6867 30.3895L37.1341 31.7579L41.9473 36L37.1341 40.2421Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2921 38.7368L69.5842 38.6C69.5842 38.0526 69.7394 37.5053 69.7394 36.9579C70.2052 24.2316 59.0263 13.4211 44.5868 12.8737V11.3684C59.9578 11.9158 72.0684 23.4105 71.4473 36.9579C71.4473 37.5053 71.2921 38.1895 71.2921 38.7368Z",
    fill: "#BCC0C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8131 47.4947C16.4842 43.6632 15.3973 39.4211 15.7079 35.0421C16.1736 25.6 22.5394 17.2526 32.4763 13.4211L33.2526 14.7895C23.7815 18.4842 17.7263 26.1474 17.4157 35.0421C17.2605 39.1474 18.1921 43.1158 20.3657 46.6737L18.8131 47.4947Z",
    fill: "#BCC0C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 60.6316C43.1895 60.6316 42.7237 60.6316 42.4132 60.6316C36.8237 60.4947 31.5447 58.7158 27.0421 55.8421L27.9737 54.6105C32.1658 57.3474 37.1342 58.8526 42.4132 59.1263C51.729 59.4 60.579 55.2947 65.5474 48.4526L67.1 49.2737C61.9763 56.2526 52.9711 60.6316 43.5 60.6316Z",
    fill: "#BCC0C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7657 53.5158L54.8341 52.1474C55.2999 51.8737 55.6104 51.7368 56.0762 51.4632C65.7025 45.4421 67.8762 33.6737 61.0446 25.1895L62.442 24.2316C69.8946 33.4 67.4104 46.1263 57.0078 52.6947C56.6973 52.9684 56.2315 53.2421 55.7657 53.5158Z",
    fill: "#BCC0C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknowError);
export default __webpack_public_path__ + "static/media/unknowError.d79919f9c10c8f08098a1eb1fa7fe7ca.svg";
export { ForwardRef as ReactComponent };